<script>
  import SideNav from "./components/SideNav.svelte";
  import MainContent from "./components/MainContent.svelte";
  import { onMount } from "svelte";

  let campusName = "Open Campus";

  onMount(() => {
  let lastURLSegment = window.location.href.substr(
      window.location.href.lastIndexOf("/") + 1
    );
  });
</script>

<noscript>Please Enable Javascript</noscript>

<div class="grid-container v-100">
  <SideNav />
  <div class="d-flex flex-column align-items-stretch flex-grow-1 panel-1">
    <div class="grid-container m-0 p-0 v-100">
      <MainContent />
    </div>
  </div>
</div>
